import { isEqual } from 'lodash'

import type { Page } from './create'

export const isPageEqual = (a: Page, b: Page, level: 'params' | 'query' | 'all') => {
	if (a.name !== b.name) return false
	if (!isEqual(a.params ?? {}, b.params ?? {})) return false
	if (level === 'params') return true
	if (!isEqual(a.query ?? {}, b.query ?? {})) return false
	if (level === 'query') return true
	return a.fragment === b.fragment
}
